/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { css } from "@panda/css";

export const richTextContentStyles = css({
	color: "eds.text.secondary",

	"& h1": {
		textStyle: "heading2XL",
	},
	"& h2": {
		textStyle: "headingXL",
	},
	"& h3": {
		textStyle: "headingLG",
	},
	"& h4": {
		textStyle: "headingMD",
	},
	"& h5": {
		textStyle: "headingSM",
	},
	"& h6": {
		textStyle: "eyebrowLG",
	},
	"& p": {
		textStyle: "paragraphLG",
		marginBlockStart: "eds.dimension.4",
		marginBlockEnd: "eds.dimension.24",
	},
	"& strong": {
		color: "eds.text.primary",
	},
	"& h1, & h2, & h3, & h4, & h5, & h6": {
		color: "eds.text.primary",
		marginBlockStart: "eds.dimension.12",
		marginBlockEnd: "eds.dimension.8",
	},
	"& table th": {
		textStyle: "uiMD",
		color: "eds.text.secondary",
		paddingBlock: "eds.dimension.8",
		paddingInline: "eds.dimension.16",
		textAlign: "start",
	},
	"& table td": {
		textStyle: "uiMD",
		color: "eds.text.primary",
		padding: "eds.dimension.16",
		background: "eds.background.elevated.low.transparent",
		borderBottom: "2px solid",
		borderBottomColor: "eds.background.default",
	},
	"& table tr:first-child td:first-child": {
		borderTopLeftRadius: "eds.borderRadius.12",
	},
	"& table tr:first-child td:last-child": {
		borderTopRightRadius: "eds.borderRadius.12",
	},
	"& table tr:last-child td:first-child": {
		borderBottomLeftRadius: "eds.borderRadius.12",
	},
	"& table tr:last-child td:last-child": {
		borderBottomRightRadius: "eds.borderRadius.12",
	},
	"& hr": {
		marginBlock: "eds.dimension.32",
		width: "100%",
		borderTopWidth: "1px",
		borderTopStyle: "solid",
		borderTopColor: "eds.border.subtle",
	},
});
